import { useEffect, useState } from 'react';
import { useEvent, useStore, useStoreMap } from 'effector-react';
import {
  Button,
  Col,
  ConfigProvider,
  Row,
  Segmented,
  Skeleton,
  Table,
  Tooltip,
  Tree,
  Typography,
} from 'antd';
import locale from 'antd/locale/ru_RU';
import { InfoOutlined } from '@ant-design/icons';
import ContainerInner from '../../components/ContentContainer/ContainerInner.jsx';
import { resetActiveFiltersEv } from '../../models/activeFiltersModel/index.js';
import MapWork from '../MapWork/MapWork.jsx';
import {
  $activitiesSelect,
  $filters,
  $orgsTable,
  $tableControl,
  $regionsTree,
  changeFiltersEv,
  changeTableStateEv,
  getOrganizationsDataFx,
  getOrganizationsTableFx,
  OrgsDashboardGate,
} from '../../models/organizationsModel/index.js';
import styles from './OrganizationsDashboard.module.css';
import FiltersBlock from './FiltersBlock.jsx';
import TableFilter from './TableFilter.jsx';
import ReportsModal from './ReportsModal.jsx';
import OrganizationsAnalytics from './AnalyticsComponents/OrganizationsAnalytics.jsx';
import OrganizationsDashboardContent from './OrganizationsDashboardContent.jsx';

function OrganizationsDashboard() {
  const [tab, setTab] = useState(0);
  const segmentedOptions = [
    {
      label: 'Перечень РСП',
      value: 0,
    },
    {
      label: 'Аналитика РСП',
      value: 1,
    },
  ];

  return (
    <ContainerInner
      title="Реестр субъектов предпринимательства"
      extra={
        <Segmented options={segmentedOptions} value={tab} onChange={setTab} />
      }
    >
      {tab === 0 ? (
        <OrganizationsDashboardContent />
      ) : (
        <OrganizationsAnalytics />
      )}
    </ContainerInner>
  );
}
export default OrganizationsDashboard;
